export const kiSuchmaschinen2025FAQData = [
  {
    question: "Wie aktuell ist ChatGPT 2025 wirklich?",
    answer: "Seit GPT-5 arbeitet ChatGPT mit mehreren Modulen (GPT-5 Main, GPT-o4, GPT-Thinking). Es nutzt Wissen bis 2024, ergänzt durch Live-Suche und Tool-Zugriff."
  },
  {
    question: "Welche Claude-Modelle gibt es aktuell?",
    answer: "Claude Opus 4.1, Sonnet 4.5 und Haiku 4.5 – gleicher Wissenskern, unterschiedliche Tiefe und Geschwindigkeit."
  },
  {
    question: "Sind KI-Suchmaschinen kostenlos?",
    answer: "Basisversionen ja, Premiumfunktionen kostenpflichtig."
  },
  {
    question: "Wie prüfe ich die Qualität einer KI-Antwort?",
    answer: "Quellen prüfen, Tools vergleichen, gesunden Menschenverstand nutzen."
  }
];
